module.exports = __webpack_public_path__ + "static/media/beach-activities.db1cabb9.jpg";